exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2G-ojSRsJfHl5fRGDf5j5D {\n  font-size: x-large;\n  position: fixed;\n  margin: -3px 3px;\n  color: #cc3d3f;\n}\n\n._2WAkW_ccIzXigFLX-LST6A {\nfont-family: Roboto;\nfont-style: normal;\nfont-weight: 400;\nfont-size: 18px;\nline-height: 21px;\ncolor: #142A39\n}\n", ""]);

// exports
exports.locals = {
	"asterisk": "_2G-ojSRsJfHl5fRGDf5j5D",
	"label": "_2WAkW_ccIzXigFLX-LST6A"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Common/CommonStyles.css
// module id = 8842
// module chunks = 23